import { Snackbar } from "@mui/material"
import { useEffect, useState } from "react"
import Button from "@mui/material/Button"

interface INotificationProps {
  message: string
  onClose?: () => void
}

export default function Notification({ message, onClose }: INotificationProps) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (message) {
      setIsOpen(true)
    }
  }, [message])

  return (
    <Snackbar
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      open={isOpen}
      message={message}
      action={
        <Button
          variant="contained"
          color="error"
          type="button"
          onClick={() => {
            setIsOpen(false)
            if (onClose) {
              onClose()
            }
          }}
        >
          {" "}
          Close{" "}
        </Button>
      }
    />
  )
}
